module.exports = __webpack_public_path__ + "img/eece15c.png";